import React, { useState, useEffect, Fragment, useContext } from "react";
import { useLocation } from "./Location.hook";
import { Modal } from "../../Modal/web"
import "./styles.less"
import { RightChevron } from "shared-components/Components/CustomIcons/RightChevron/web";
import { Skeleton } from "./Skeleton";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getTraduction } from "src/functions/functions";
import { capitalize } from "@Utils/Functions";

export const Location = ({ ...props }: any) => {
    const [filteredEstates, setFilteredEstates] = useState([])
    const [locationModal, setLocationModal] = useState<number>(0)
    const [filteredNeighbourhoods, setFilteredNeighbourhoods] = useState([])
    const [selectedLocations, setSelectedLocations] = useState<any>({})
    const [modalNeighbourhoods, setModalNeighbourhoods] = useState([])
    const [modalEstates, setModalEstates] = useState([])
    const [currentEstate, setCurrentEstate] = useState<any>({})
    const [currentOpenEstate, setCurrentOpenEstate] = useState<any>({})
    const {
        estates,
        getNeighbourhoodsByEstateId,
        neighbourhoods,
        neighbourhoodsLoading
    } = useLocation(props)
    const { country_code } = useContext(ConfigStateContext);

    const currentNeighbourhood = props.currentNeighbourhood

    useEffect(() => {
        if (estates) {
            setCurrentEstate(estates.find(estate => estate.id == props.currentEstate))
            getNeighbourhoodsByEstateId(props.currentEstate)

            const sortedArray = estates
                .map((e) => ({ ...e }))
                .sort((a, b) => a.name.localeCompare(b.name));

            const transformedArray = sortedArray.reduce((result, estate) => {
                const initialLetter = estate.name.charAt(0).toUpperCase();
                const foundObj = result.find((obj) => obj.letter == initialLetter);
                if (foundObj) {
                    foundObj.estates.push(estate);
                } else {
                    result.push({ letter: initialLetter, estates: [estate] });
                }
                return result;
            }, []);
            setFilteredEstates(transformedArray)
            setModalEstates(transformedArray)
        }

        if (neighbourhoods && !!neighbourhoods.length) setFilteredNeighbourhoods([...modalNeighbourhoods]);

        if (currentOpenEstate && Object.keys(currentOpenEstate).length === 0 && currentEstate) {
            setCurrentOpenEstate(currentEstate);
        }
    }, [estates, modalNeighbourhoods]);

    useEffect(() => {
        if (neighbourhoods) {
            const { neighborhoods } = neighbourhoods
            const sortedArray = neighborhoods
                .map((neighbourhood) => ({ ...neighbourhood }))
                .sort((a, b) => a.name.localeCompare(b.name));

            const transformedArray = sortedArray.reduce((result, neighbourhood) => {
                const letter = neighbourhood.name.charAt(0).toUpperCase();
                const foundObj = result.find((obj) => obj.letter === letter);
                if (foundObj) {
                    foundObj.neighbourhoods.push(neighbourhood);
                } else {
                    result.push({ letter, neighbourhoods: [neighbourhood] });
                }
                return result;
            }, []);

            if (currentNeighbourhood && currentEstate) {
                const selectedNeighborhoods = neighborhoods.filter(v => currentNeighbourhood.map((n) => n.toString()).includes(v.id))
                const res = {
                    name: currentEstate.name,
                    id: currentEstate.id,
                    neighbourhoods: selectedNeighborhoods
                }
                setSelectedLocations(res)
            }
            else if (!currentNeighbourhood) {
                setSelectedLocations({
                    ...selectedLocations,
                    neighbourhoods: []
                })
            }
            setModalNeighbourhoods(transformedArray)
            setFilteredNeighbourhoods(transformedArray)
        }
    }, [neighbourhoods, currentNeighbourhood])

    const handleToggleModal = () => {
        if (currentEstate && props.currentEstate) setLocationModal(2)
        else setLocationModal(1)
    }

    const closeModal = () => setLocationModal(0)

    const backEvent = () => {
        setLocationModal(1)
        clearContext()
    }

    const clearContext = () => {
        props.changeFilters({ estate_id: null, neighborhood_id: null })
        setSelectedLocations({ ...selectedLocations, neighbourhoods: [] })
    }

    const handleSelectEstate = async (estate) => {
        if (estate.id !== selectedLocations.id && !currentNeighbourhood) {
            setCurrentOpenEstate(estate)
            const res = {
                name: estate.name,
                id: estate.id,
                neighbourhoods: []
            }
            setSelectedLocations(res);

            getNeighbourhoodsByEstateId(estate.id)
            setTimeout(() => setLocationModal(2), 300)
        } else {
            setLocationModal(2)
        }
    }

    const handleSelectNeighbourhood = (newNeighbourhood) => {

        const existingIndex = selectedLocations.neighbourhoods ? selectedLocations.neighbourhoods.findIndex(neighbourhood => neighbourhood.id === newNeighbourhood.id) : -1;


        if (existingIndex !== -1) {
            const updatedNeighbourhoods = [...selectedLocations.neighbourhoods];
            updatedNeighbourhoods.splice(existingIndex, 1);
            setSelectedLocations(prevState => ({
                ...prevState,
                neighbourhoods: updatedNeighbourhoods
            }));
        } else {
            setSelectedLocations(prevState => ({
                ...prevState,
                neighbourhoods: [...prevState.neighbourhoods, newNeighbourhood]
            }));
        }
    }

    const handleSearchChange = (event) => {
        const inputValue = event.target.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        if (inputValue === "") {
            setFilteredEstates([...modalEstates]);
        }
        else {
            const filteredArray = [...modalEstates].map((item) => {
                const newFilteredEstates = item.estates.filter(
                    (estate) =>
                        estate.name.toLowerCase().startsWith(inputValue.toLowerCase())
                );

                return {
                    letter: item.letter,
                    estates: newFilteredEstates,
                };
            });

            const finalArray = filteredArray.filter(
                (item) => item.estates.length > 0
            );

            setFilteredEstates(finalArray);
        }
    };

    const handleSearchNeighbourhoods = (event) => {
        const inputValue = event.target.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        if (inputValue === "") {
            setFilteredNeighbourhoods([...modalNeighbourhoods]);
        } else {
            const filteredArray = [...modalNeighbourhoods].map((item) => {
                const filteredNeighbourhoods = item.neighbourhoods.filter(
                    (neighbourhood) =>
                        neighbourhood.name.toLowerCase().startsWith(inputValue.toLowerCase())
                );

                return {
                    letter: item.letter,
                    neighbourhoods: filteredNeighbourhoods,
                };
            });

            const finalArray = filteredArray.filter(
                (item) => item.neighbourhoods.length > 0
            );

            setFilteredNeighbourhoods(finalArray);
        }
    };

    const handleFilter = () => {
        const estate = {
            value: selectedLocations.id ? Number(selectedLocations.id) : currentEstate.id ? currentEstate.id : null,
            text: selectedLocations.name ? selectedLocations.name : currentEstate.name ? currentEstate.name : null
        }

        const neighbourhoodsArray = [];

        if (selectedLocations && selectedLocations.neighbourhoods) {
            selectedLocations.neighbourhoods?.forEach(neighborhood => {
                neighbourhoodsArray.push({
                    value: Number(neighborhood.id),
                    text: neighborhood.name
                });
            });
        }

        props.changeFilters({
            //@ts-ignore
            estate_id: estate,
            neighborhood_id: neighbourhoodsArray
        })
        setLocationModal(0)
    }

    const EstatePill = ({ estate }) => (
        <div
            className="estate-item"
        >
            <span onClick={() => handleSelectEstate(estate)}>{estate.name}</span>
        </div>
    );

    const maxPriorityEstates = 5 //cantidad de destacados
    const priorityEstates = estates.slice(0, maxPriorityEstates)

    return (
        <div className="estate-list-container">
            <button onClick={handleToggleModal} className="estate-see-more">
                <span className="title">Ubicaciones</span>
                <DownArrow />
            </button>

            <Modal
                show={locationModal === 1 ? true : false}
                width="800px"
                title="Departamentos"
                onClose={closeModal}
            >
                <>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="search-departaments"
                        onChange={handleSearchChange}
                    />

                    <div className="estate-list">
                        <h3 className="title-estate-list">Seleccione el departamento que desea buscar</h3>
                        {modalEstates.length === filteredEstates.length && <><h3 className="title-section-location">Destacados</h3>{priorityEstates.map((estate, index) => (
                            <EstatePill
                                key={index}
                                estate={estate}
                            />
                        ))}</>}
                        {filteredEstates?.length && filteredEstates.map((value, index) => (
                            <Fragment key={'estate : ' + index}>
                                <h3 className="title-section-location">{value.letter}</h3>
                                {value.estates.map((e, i) => <div key={e.name + i} className="neighbourhoods-list">
                                    <EstatePill
                                        estate={e}
                                    />
                                </div>)}
                            </Fragment>
                        ))}
                    </div>
                </>
            </Modal>

            <Modal
                show={locationModal === 2 ? true : false}
                width="800px"
                onClose={closeModal}
                title={
                    <div className="header-modal-neighbourhood">
                        <button
                            className="back-modal"
                            onClick={backEvent}
                        >
                            <RightChevron width={25} />
                        </button>
                        {capitalize(getTraduction("barrio", country_code))}s de {currentOpenEstate && currentOpenEstate.name}
                    </div >
                }
                footer={
                    < button
                        className="btn-filter"
                        onClick={handleFilter}
                    >
                        Aplicar búsqueda
                    </button >
                }
            >
                <>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="search-departaments"
                        onChange={handleSearchNeighbourhoods}
                    />

                    {neighbourhoodsLoading && <Skeleton />}

                    {!neighbourhoodsLoading &&
                        <div>
                            {filteredNeighbourhoods?.length && filteredNeighbourhoods.map((neighbourhood, index) => (
                                <div className="neighbourhoods-container" key={index}>
                                    <h3 className="title-section-location">{neighbourhood.letter}</h3>
                                    <div className="neighbourhoods-list">
                                        {neighbourhood.neighbourhoods?.map((n, index) => {
                                            const isSelected = selectedLocations.neighbourhoods?.some(neighbourhood => neighbourhood.id === n.id);

                                            return (
                                                <span
                                                    className={"neighbourhood-item " + (isSelected ? "active" : "")}
                                                    key={index}
                                                    onClick={() => handleSelectNeighbourhood(n)}
                                                >{n.name}</span>
                                            )
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                </>
            </Modal >
        </div >
    )
}